import Header from 'components/Common/Header/Header';
import GroupProductImagesBody from 'components/GroupComponents/GroupDetails/GroupProduct/GroupProductDetails/GroupProductImages/GroupProductImagesBody/GroupProductImagesBody';
import React from 'react';

const GroupProductImages = () => {
  return (
    <>
      {/* ---- header start ---- */}
      <Header moduleName="group" />
      {/* --- header end --- */}

      {/* ----------- body section ------------ */}
      <GroupProductImagesBody />
    </>
  );
};

export default GroupProductImages;
